import { processes } from '../../utils/Helper';

export const PROCESS_DATA = 'PROCESS_DATA';
export const TICKET_REFERENCES = 'TICKET_REFERENCES';
export const RESET = 'RESET';

export const getProcessId = (id, subId) => `${id}${parseInt(subId, 10) > 0 ? `.${subId}` : ''}`;

const processesOrder = {
  [processes.ORDER]: 1,
  [processes.OFFER]: 1,
  [processes.TRADE]: 2,
  [processes.BULK_ORDER]: 1,
  [processes.BASKET_ORDER]: 1,
  [processes.DEPOSIT]: 1,
  [processes.BULK_DEPOSIT]: 1,
  [processes.WITHDRAW]: 1,
  [processes.BULK_WITHDRAW]: 1,
  [processes.TRANSFER]: 1,
  [processes.CORP_EVENT]: 1,
  [processes.TRANSACTION]: 1,
  [processes.PRODUCT_ACTIVITY]: 3,
  [processes.CASH_ACTIVITY]: 3,
  [processes.INVOICE]: 4,
  [processes.JOURNAL_ENTRY]: 5,
};

const normalizeReferences = (refs) => {
  const sorted = refs.sort((a, b) => (
    (processesOrder[a.process] || 6) - processesOrder[b.process] || 6));
  const newRefs = [];
  sorted.forEach((ref, index) => {
    if (index === 0 || newRefs[newRefs.length - 1].process !== ref.process) {
      newRefs.push({
        process: ref.process,
        ids: [{ id: ref.id, subId: ref.subProcessId }],
      });
    } else {
      newRefs[newRefs.length - 1].ids.push({ id: ref.id, subId: ref.subProcessId });
    }
  });
  return newRefs;
};

export const initializeState = () => ({
  references: undefined,
  parent: { id: undefined },
  childs: undefined,
  ticketNumber: undefined,
  actions: {},
});

export const reducer = (state, { type, payload }) => {
  const newState = { ...state };
  switch (type) {
    case TICKET_REFERENCES:
      newState.references = [];
      payload.references.forEach(({ id, process, subProcessId }) => {
        newState.references.push({ id, process, subProcessId });
        if (!newState[process]) {
          newState[process] = {
            [getProcessId(id, subProcessId)]: {
              loading: true,
            },
          };
        } else {
          newState[process] = {
            ...newState[process],
            [getProcessId(id, subProcessId)]: {
              loading: true,
            },
          };
        }
      });
      newState.references = normalizeReferences(newState.references);
      newState.parent = payload.parent;
      newState.childs = payload.childs;
      newState.ticketNumber = payload.ticketNumber;
      newState.ticketMainProcess = payload.ticketMainProcess;
      newState.ticketMainProcessId = payload.ticketMainProcessId;
      newState.ticketMainSubProcessId = payload.ticketMainSubProcessId;
      newState.isRolledback = payload.isRolledback;
      newState.isHidden = payload.isHidden;
      newState.actions = payload.actions;
      return newState;
    case PROCESS_DATA:
      if (!newState[payload.process]) {
        newState[payload.process] = {
          [payload[payload.id]]: { ...payload[payload.process] },
        };
      } else {
        newState[payload.process] = {
          ...newState[payload.process],
          [getProcessId(payload.id, payload.subId)]: { ...payload[payload.process] },
        };
      }
      return newState;
    case RESET:
      return {
        references: undefined,
        parent: { id: undefined },
        childs: undefined,
        ticketNumber: payload.ticketNumber,
        actions: {},
      };
    default:
      return newState;
  }
};
